module.exports = __webpack_public_path__ + "static/img/far4_active.2855cc85.png";